import { useEffect, useState } from "react";
import { UserRoles } from "fe-common/graphql";
import { useDaoContext } from "../diseaseview/DaoContext";

export function useGetUserRoles() {
  const [roles, setRoles] = useState<UserRoles[]>(null);

  const [loading, setLoading] = useState(true);
  const dao = useDaoContext();

  useEffect(() => {
    let isMounted = true; // Keep a flag to avoid trying to update the state when the component is unmounted
    async function fetchData() {
      try {
        setLoading(true);
        if (isMounted) {
          const userRules = await dao.getUserRoles();
          setRoles(userRules as UserRoles[]);
        }
      } catch (e) {
      } finally {
        if (isMounted) setLoading(false);
      }
    }
    if (!roles) fetchData();
    return () => (isMounted = false); // Make sure to mark the component as unmounted when removed from dom
  }, []);

  return { loading, roles: roles || [] };
}
